import {PARTNER_GUARD_INVESTMENT_RISK} from '../Reducer/PartnerGuardInvestmentRisk';
import {ApiPartnerGuardInvestmentRisk} from '../Api';

export function PartnerGuardInvestmentRiskThunk() {
    return (dispatch,getState)=>{
        ApiPartnerGuardInvestmentRisk()
        .then((result)=>{
            dispatch({
                type:PARTNER_GUARD_INVESTMENT_RISK,
                payload:{
                    result:result.data.data
                }
            })
        })
    }
}
